<template>
  <div class="row">
    <!--<span style="display:none">{{heartBeat}}</span>-->
    <!--{{book}}{{highLightTerm}}{{bookRecord}}-->
    <div class="row">
      <template v-if="!bookRecord">
        <div class="animated-background">
          <div class="background-masker header"></div>
          <div class="background-masker header-no"></div>  
          <div class="background-masker header2"></div>  
          <div class="background-masker header-no2"></div>
          <div class="background-masker header3"></div>
        </div>
      </template>
      <template v-else-if="!cite">
      <h4 v-if="bookRecord.title">{{bookRecord.title}}<template v-if="bookRecord.creator">. {{Array.isArray(bookRecord.creator) ? bookRecord.creator.length > 2 ? `${bookRecord.creator.slice(0,2).join(',')}...` : bookRecord.creator.join(', ') : bookRecord.creator}}.</template>
      <template v-if="bookRecord.date && showDate">({{Array.isArray(bookRecord.date) ? bookRecord.date[0] : bookRecord.date}}).</template>
      <template v-if="bookRecord.edition"><br/>{{Array.isArray(bookRecord.edition) ? bookRecord.edition[0] : bookRecord.edition}}.</template>
      </h4>
      <h4 v-if="bookRecord.collection">{{$t('collection')}}:{{bookRecord.collection}}</h4>
      </template>
      <template v-else>
      <h4>{{cite}}</h4>
      </template>
    </div>
    <template v-if=" hits !== null && hits.numFound > 0">
      <h4>{{hits.numFound}} {{$t('of')}} {{noOfAllPages}} {{$t('hitsPageInTitle2')}} {{$t('hitsPageInTitle')}} {{highLightTerm.join(" and ")}} </h4>
      <!--<BarChart v-if="fetched" :hits="hits" :noOfPages="book.noOfpages" :eleWidth="$el.clientWidth"></BarChart>-->
      <!--Terms distribution <span @click="refresh"><icon name="refresh" scale="0.8"></icon></span><hr/>-->
      <div class="pages" style="padding-left: 1em;padding-right: 1em;border-left:outset;border-left-color:#ddd">
      <!--<template v-if="fetched">-->
      <!--  <DynamicScroller :items="hits" :min-item-height="60" class="full_text_scroller">-->
      <!--    <template slot-scope="{ item, index, active }">-->
      <!--      <DynamicScrollerItem :item="item" :active="active" :size-dependencies="[item.title, item.title, item.text]" :data-index="index">-->
      <!--        <br/>-->
      <!--        <div class="row">p.{{item.position}} <template v-if="item.url && item.url.length > 0"><span v-tooltip="$t('gotoXPage')"><a target="_blank" class='xAsia' :href='item.url'><icon name="file"></icon></a></span><span v-if="'original' in fieldsMapping[book.source]" v-tooltip="$t('gotoPage')"><a target="_blank" :href='item.url.replace(fieldsMapping[book.source].XAsia,fieldsMapping[book.source].original)'><icon name="file"></icon></a></span></template><template v-if="item.imageUrl && item.imageUrl.length > 0"><span v-tooltip="$t('gotoXImage')"><a target="_blank" class='xAsia' :href='item.imageUrl'><icon name="file"></icon></a></span><span v-if="'original' in fieldsMapping[book.source]" v-tooltip="$t('gotoImage')"><a target="_blank" :href='item.imageUrl.replace(fieldsMapping[book.source].XAsia,fieldsMapping[book.source].original)'><icon name="file"></icon></a></span></template></div>-->
      <!--        <div v-if="item.title" class="row article">{{fieldsMapping[book.source].unitTitle}}: {{item.title}}<template v-if="hit.creator" class="row">, {{item.creator.join(', ')}}</template></div>-->
      <!--        <div class="row fulltext">-->
      <!--          <span v-html="highLight(item.text, item.expand)"></span>-->
      <!--        </div>-->
      <!--        <hr/>-->
      <!--      </DynamicScrollerItem>-->
      <!--    </template>-->
      <!--  </DynamicScroller>-->
      <!--</template>-->
      
      <template v-if="fetched">
        <!--<virtual-list :size="20" :remain="Math.min(hits.length, 50)" :bench="Math.max(hits.length -50, 0)">-->
        <!--    <template v-for="hit in hits">-->
        <!--      <div class="row">p.{{hit.position}} <template v-if="hit.url && hit.url.length > 0"><span v-tooltip="$t('gotoXPage')"><a target="_blank" class='xAsia' :href='hit.url'><icon name="file"></icon></a></span><span v-if="'original' in fieldsMapping[book.source]" v-tooltip="$t('gotoPage')"><a target="_blank" :href='hit.url.replace(fieldsMapping[book.source].XAsia,fieldsMapping[book.source].original)'><icon name="file"></icon></a></span></template><template v-if="hit.imageUrl && hit.imageUrl.length > 0"><span v-tooltip="$t('gotoXImage')"><a target="_blank" class='xAsia' :href='hit.imageUrl'><icon name="file"></icon></a></span><span v-if="'original' in fieldsMapping[book.source]" v-tooltip="$t('gotoImage')"><a target="_blank" :href='hit.imageUrl.replace(fieldsMapping[book.source].XAsia,fieldsMapping[book.source].original)'><icon name="file"></icon></a></span></template></div>-->
        <!--      <div v-if="hit.title" class="row article">{{fieldsMapping[book.source].unitTitle}}: {{hit.title}}<template v-if="hit.creator" class="row">, {{hit.creator.join(', ')}}</template></div>-->
        <!--      <div class="row fulltext">-->
        <!--        <span v-html="highLight(hit.text, hit.expand)"></span>-->
        <!--        <template v-if="!hit.expand"><span v-html="highLight(hit.text, hit.expand)"></span><a @click="hit.expand = true">... more</a></template><template v-else><span v-html="highLight(hit.text, hit.expand)"></span><a @click="hit.expand = false">... less</a></template>-->
        <!--        </div>-->
        <!--      <hr/>-->
        <!--    </template>-->
        <!--</virtual-list>-->
      <!--noOfpages:{{noOfpages}}, page:{{page}}, noPerPage:{{noPerPage}}-->
      <Paginate :noofpages.sync="noOfpages" :page.sync="page" v-on:goto="goto" :noPerPage="noPerPage" :showrecordscount="false" :maxofrecords="0"></Paginate>
      <template v-for="hit in hits.hits">
        <span>
          <!-- {{book}} -->
        <div class="row"><template v-if="fieldsMapping[book[2]].unit != 'Article'">p.</template>{{hit.position}} <template v-if="hit.volume">(vol.{{hit.volume}}, p.{{hit.position_vol}})</template>
          <template v-if="showPageLink && hit.url && hit.url.length > 0 && ['itr-maoistlegacy-db', 'itr-buddhist-road', 'itr-dtab'].indexOf(book[2]) == -1">
            <template v-if="hit.url !== urlRewrite(hit.url, book[2])">
              <span v-if="'XAsia' in fieldsMapping[book[2]]" v-tooltip="$t('gotoXPage')">
                <a target="_blank" class='xAsia' :href='hit.url'><icon name="file"></icon></a>
              </span>
            </template>
            <span v-if="'original' in fieldsMapping[book[2]]" v-tooltip="$t('gotoPage')">
                <a :class='(["itr-sbb-digital", "itr-ead-digital", "itr-buddhist-road", "itr-dtab"].indexOf(book[2]) > -1 ? "open": ["itr-maoistlegacy-db"].indexOf(book[2]) > -1 ? "openButLoginRequired" : "")' target="_blank" :href="urlRewrite(hit.url, book[2])" ><icon name="file"></icon></a>
            </span>
          </template>
          <template v-if='hit.imageUrl && hit.imageUrl.length > 0 && (["itr-ead-digital"].indexOf(book[2]) == -1)'>
            <span v-if="'XAsia' in fieldsMapping[book[2]]" v-tooltip="$t('gotoXImage')">
              <a target="_blank" class='xAsia' :href='hit.imageUrl'><icon name="file"></icon></a>
            </span>
            <span v-if="'original' in fieldsMapping[book[2]]" v-tooltip="$t('gotoImage')">
              <a target="_blank" :class='(["itr-sbb-digital", "itr-ead-digital", "itr-buddhist-road", "itr-dtab"].indexOf(book[2]) > -1 ? "open": ["itr-maoistlegacy-db"].indexOf(book[2]) > -1 ? "openButLoginRequired" : "")' :href="urlRewrite(hit.imageUrl, book[2])" ><icon name="file"></icon></a>
            </span>
          </template>
        </div>
        <div v-if="hit.title" class="row article">{{hit.title}}<template v-if="hit.creator" class="row">, {{hit.creator.join(', ')}}</template></div>
        <div class="row fulltext">
          {{hit.articleTitle}}<br/>
          <span v-html="highLight(hit.text, hit.expand)"></span>
          <!--<template v-if="!hit.expand"><span v-html="highLight(hit.text, hit.expand)"></span><a @click="hit.expand = true">... more</a></template><template v-else><span v-html="highLight(hit.text, hit.expand)"></span><a @click="hit.expand = false">... less</a></template>-->
          </div>
        <hr/>
        </span>
      </template>
      <Paginate :noofpages.sync="noOfpages" :page.sync="page" v-on:goto="goto" :noPerPage="noPerPage" :showrecordscount="false" :maxofrecords="0"></Paginate>
      </template>
      </div>
    </template>
  </div>
</template>

<script>
import Vue from 'vue'
import AsyncComputed from 'vue-async-computed'
// import BarChart from './BarChart'
import 'vue-awesome/icons/refresh'
import 'vue-awesome/icons/file'
import Icon from 'vue-awesome/components/Icon'
import chineseTranslator from '../assets/_chineseTranslator'
// import chineseTranslator from 'chinese-utils'
import Paginate from './Paginate'
import range from 'lodash/range'
// import VueVirtualScroller from 'vue-virtual-scroller'

// import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

// import virtualList from 'vue-virtual-scroll-list'

Vue.component('icon', Icon)

Vue.use(AsyncComputed)
const _ = {range: range}

// const inject = (str, obj) => str.replace(/\${(.*?)}/g, (x, g) => obj[g])
// Vue.use(VueVirtualScroller)
// Fetch the solr fields and fulltext based on the defined fields mapping.
export default {
  name: 'pageCluster',
  props: ['book', 'highLightTerm', 'charToShow', 'wordToShow'],
  data: function () {
    return {
      fetched: false,
      // noOfpages: [0, 1, 2, 3],
      noPerPage: 10,
      page: 0,
      noOfAllPages: 0,
      record: {},
      cite: false
    }
  },
  components: {
    // BarChart,
    Icon,
    Paginate
    // 'virtual-list': virtualList
  },
  i18n: { // `i18n` option
    messages: {
      en: {
        title: 'Title',
        'of': 'of',
        date: 'Date',
        author: 'Authors',
        edition: 'Edition',
        collection: 'Collection',
        hitsPageInTitle: 'contain the search term(s) ',
        hitsPageInTitle2: 'pages of this title',
        gotoImage: 'Provider Link',
        gotoXImage: 'CrossAsia Licensed',
        gotoPage: 'Provider Link',
        gotoXPage: 'CrossAsia Licensed'
      },
      de: {
        title: 'Titel',
        'of': 'von',
        // language: 'sprache',
        // subject: 'themengebiete',
        date: 'Datum',
        author: 'Autoren',
        edition: 'Ausgabe',
        collection: 'Kollektion',
        hitsPageInTitle: 'enthalten den/die Suchbegriff(e)',
        hitsPageInTitle2: 'Seiten dieses Titels ',
        gotoImage: 'Provider Link',
        gotoXImage: 'CrossAsia Licensed',
        gotoPage: 'Provider Link',
        gotoXPage: 'CrossAsia Licensed'
      }
    }
  },
  computed: {
    fieldsMapping: function () {
      return this.$store.state.collections.setting.fieldsMapping
    },
    sources: function () {
      return this.$store.state.collections.setting.sources
    },
    showDate: function () {
      return ('showDate' in this.fieldsMapping[this.book[2]]) ? this.fieldsMapping[this.book[2]].showDate : true
    },
    showPageLink: function () {
      // console.log(this.fieldsMapping[this.book[2]])
      return ('showPageLink' in this.fieldsMapping[this.book[2]]) ? this.fieldsMapping[this.book[2]].showPageLink : true
    },
    creator: function () {
      // if (this.resultBlock.pages.length > 0 && this.dataSource[this.resultBlock.pages[0]] !== null) {
      //   if (this.metadata[this.resultBlock.source + this.dataSource[this.resultBlock.pages[0]][this.fieldsMap.book_id]] !== null) {
      //     return this.metadata[this.resultBlock.source + this.dataSource[this.resultBlock.pages[0]][this.fieldsMap.book_id]][this.fieldsMap.creator] ? this.metadata[this.resultBlock.source + this.dataSource[this.resultBlock.pages[0]][this.fieldsMap.book_id]][this.fieldsMap.creator].join(',') : ''
      //   }
      // }
      return Array.isArray(this.book.creator) ? this.book.creator.join(' ') : this.book.creator
    },
    noOfpages: function () {
      let totalPage = parseInt(this.noOfAllPages / this.noPerPage + (this.noOfAllPages % this.noPerPage === 0 ? 0 : 1))
      // console.log(this.noOfAllPages, this.noPerPage, totalPage, (this.noOfAllTitles % this.noPerPage === 0 ? 0 : 1), (parseInt(this.noOfAllTitles) % parseInt(this.noPerPage)))
      // console.log(totalPage)
      if (totalPage < 8) {
        return _.range(0, totalPage)
      } else {
        let start = Math.max(0, this.page - 3)
        let end = Math.min(start + 9, totalPage)
        if ((start + 9) > totalPage) {
          end = totalPage
          start = Math.max(0, end - 9)
        }
        return _.range(start, end)
      }
    }
  },
  mounted () {
  },
  asyncComputed: {
    async bookRecord () {
      let source = this.sources[this.book[2]]
      let fieldsMap = this.fieldsMapping[this.book[2]]
      console.log(fieldsMap)
      let bookId = this.book[0]
      let result = await $.ajax({
        'url': source.url,
        'cache': true,
        'traditional': true,
        'data': {
          'rows': '1',
          'wt': 'json',
          // 'csv.header': 'false',
          // 'fl': '*,hits:[subquery]',
          // 'fl': 'id,title_txt_cjk,creator_ss,url_sss,opacUrl_sss,databaseUrl_sss,noOfpages_sss,issued_sss,hits:[subquery]',
          'fl': [`${fieldsMap.title.split('|').map(t => `title:${t}`).join(',')}`, `${fieldsMap.url.split('|').map(t => `url:${t}`).join(',')}`, `creator:${fieldsMap.creator}`, `edition:${fieldsMap.edition}`, `date:${fieldsMap.date}`, `collection:${fieldsMap.collection}`, `noOfpages:${fieldsMap.noOfpages}`, `databaseurl:${fieldsMap.databaseurl}`, `publicationName:${fieldsMap.publicationName}`, `volume:${fieldsMap.volume}`, `position_vol:${fieldsMap.position_vol}`, `date:${fieldsMap.date}`].join(','),

          // 'fl': '*,[child parentFilter=hasModel_sss:Book childFilter=' + vm.terms.map(function (term) { return [text, term].join(':') }).join(' AND ') + ']',
          'q': `id:${bookId}`
        },
        'dataType': 'jsonp',
        'jsonp': 'json.wrf'
      })
      // console.log(result)
      if (result.response.docs.length > 0) {
        result.response.docs[0].collection = Array.isArray(result.response.docs[0].collection) ? result.response.docs[0].collection.join('') : result.response.docs[0].collection
        result.response.docs[0].edition = Array.isArray(result.response.docs[0].edition) ? result.response.docs[0].edition.join('') : result.response.docs[0].edition
        result.response.docs[0].url = Array.isArray(result.response.docs[0].url) ? result.response.docs[0].url.join('') : result.response.docs[0].url
        result.response.docs[0].noOfpages = Array.isArray(result.response.docs[0].noOfpages) ? result.response.docs[0].noOfpages.join('') : result.response.docs[0].noOfpages
        result.response.docs[0].databaseurl = Array.isArray(result.response.docs[0].databaseurl) ? result.response.docs[0].databaseurl.join('') : result.response.docs[0].databaseurl
        // if (fieldsMap.articleTitle) {
        //   result.response.docs[0].articleTitle = Array.isArray(result.response.docs[0].articleTitle) ? result.response.docs[0].articleTitle.join('') : result.response.docs[0].databaseurl
        // }
      }
      this.record = result.response.docs[0]
      return result.response.docs[0]
    },
    async hits () {
      const getQ = function (vm, sourceKey) {
        const fieldsMap = vm.fieldsMapping[sourceKey]
        // console.log(fieldsMap)
        const textFields = fieldsMap.text.split('|')
        const terms = vm.highLightTerm.map(function (term) {
          // console.log(term, chineseTranslator.expandTerms2(term))
          return chineseTranslator.expandTerms2(term)
        })
        // console.log(terms)
        const userQuery =
        (vm.highLightTerm.length > 0 ? '(' + textFields.map(textField => {
          return '(' + terms.map(function (term) {
            const NOT = term[0].startsWith('"-') ? '-' : ''
            return NOT + '(' + term.map(function (t) {
              return [textField, (t.startsWith('"-') ? '"' + t.substring(2) : t)].join(':')
            }).join(' OR ') + ')'
          }).join(' AND ') + ')'
        }).join(' OR ') + ')' : '')
        console.log(vm.$store.getters['collections/getSelectedFacets'])
        const selectedFacets = vm.$store.getters['collections/getSelectedFacets']
        const facetedQuery = '(' + Object.keys(selectedFacets).map(function (key) {
          if (selectedFacets[key].length > 0) {
            return '(' + selectedFacets[key].map(x => [fieldsMap[key], '"' + x.facet + '"'].join(':')).join(' OR ') + ')'
          } else {
            return []
          }
        }).filter(function (array) {
          return array.length > 0
        }).flat().join(' AND ') + ')'
        // console.log(facetedQuery)
        return `${userQuery} ${facetedQuery.length > 2 ? ` ${(userQuery.trim().length > 0 ? 'AND' : '')} ${facetedQuery}` : ''}`
      }
      // console.log(getQ(this, this.book[2]))
      // let cacheId = [this.book[2], this.book[0]].join('|')
      // console.log(this.$store.getters['records/getCachedpages')
      // let fetched = this.$store.getters['records/getCachedpages'](cacheId)
      // if (fetched) {
      //   console.log('cache hits')
      //   this.fetched = true
      //   return fetched
      // }
      // let hits = []
      let source = this.sources[this.book[2]]
      let fieldsMap = this.fieldsMapping[this.book[2]]
      let highLightTerm = this.highLightTerm
      // console.log(this.highLightTerm)
      let terms = highLightTerm.filter(function (obj) {
        return typeof obj === 'string' || obj instanceof String
      }).map(function (term) {
        return term
// .replace(/\s*/g, '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') }).filter(function (term) { console.log(term); return term.length > 0
      })
      // console.log(terms)
      // terms = terms.map(function (term) { return term.replace(/\s*/g, '') })

      let bookId = this.book[0]
      let texts = fieldsMap.text.split('|')
      // source === ''
      // fieldsMap === ''
      // highLightTerm === ''
      // bookId === ''
      // terms === ''
      // terms === bookId
      let vm = this
      let result = await $.ajax({
        'url': source.url,
        'cache': true,
        'traditional': true,
        'data': {
          'rows': this.noPerPage,
          'start': this.page * this.noPerPage,
          'wt': 'json',
          // 'q': [fieldsMap.book_id, bookId].join(':'),
          'q': getQ(vm, this.book[2]) + ' AND (' + [fieldsMap.book_id, bookId].join(':') + ')',
          // 'fl': [fieldsMap.position, fieldsMap.text, fieldsMap.url, fieldsMap.imageUrl, fieldsMap.title, fieldsMap.creator].join(', '),
          'fl': [fieldsMap.id, fieldsMap.position, `${fieldsMap.url.split('|').map(t => `url:${t}`).join(',')}`, fieldsMap.imageUrl, fieldsMap.volume, fieldsMap.position_vol, fieldsMap.articleTitle, fieldsMap.creator].filter(x => x).join(', '),
          // 'fq': [[fieldsMap.has_model, fieldsMap.Page].join(':'), texts.map(text => { return '(' + terms.map(function (term) { return [term.startsWith('-') ? '-' : '' + text, '' + chineseTranslator.expandTerms(term.startsWith('-') ? term.substring(1) : term) + ''].join(':') }).join(' AND ') + ')' }).join(' OR ')],
          'hl': true,
          'hl.fl': texts[0],
          'hl.snippets': 1000,
          'hl.fragsize': this.fieldsMapping[this.book[2]].displayUnit === 'word' ? 80 : 40,
          'hl.tag.pre': '',
          'hl.tag.post': '',
          'hl.q': terms.length > 0 ? texts.map(text => { return '(' + terms.map(function (term) { return [text, '' + chineseTranslator.expandTerms(term) + ''].join(':') }).join(' AND ') + ')' }).join(' OR ') : ''

          // ,
          //   [fieldsMap.position, '(' + this.book.hits.map(x => x.position).join(' OR ') + ')'].join(':')
        },
        'dataType': 'jsonp',
        'jsonp': 'json.wrf'
      })
      // console.log(result)
      this.noOfAllPages = result.response.numFound

      let textMap = result.highlighting

      let hits = result.response.docs.map(function (hit) {
        // console.log(hit[fieldsMap.text].match(new RegExp('(' + highLightTerm.join('|') + ')', 'gi')))
        // return {'text': hit[fieldsMap.text], 'position': hit[fieldsMap.position], 'count': 1}
        // console.log(JSON.stringify({'text': hit[fieldsMap.text], 'position': hit[fieldsMap.position]}))
        // console.log(textMap === null)
        // console.log(hit)
        return {
          'id': hit[fieldsMap.id],
          'expand': true,
          // 'text': 'text',
          'text': (textMap[hit[fieldsMap.id]][fieldsMap.text.split('|')[0]] || ['', '']).join('....').replace(/<\/?em>/gm, ''),
          'position': Array.isArray(hit[fieldsMap.position]) ? hit[fieldsMap.position].join('') : hit[fieldsMap.position],
          'volume': fieldsMap.volume ? (Array.isArray(hit[fieldsMap.volume]) ? hit[fieldsMap.volume].join('') : hit[fieldsMap.volume]) : null,
          'position_vol': fieldsMap.position_vol ? (Array.isArray(hit[fieldsMap.position_vol]) ? hit[fieldsMap.position_vol].join('') : hit[fieldsMap.position_vol]) : null,
          // 'title': hit[fieldsMap.title] || '',
          // 'publicationName': hit[fieldsMap.publicationName] || null,
          'creator': hit[fieldsMap.creator] || null,
          'url': (Array.isArray(hit['url']) ? hit['url'].join('') : hit['url']) || '',
          'imageUrl': (Array.isArray(hit[fieldsMap.imageUrl]) ? hit[fieldsMap.imageUrl].join('') : hit[fieldsMap.imageUrl]) || '',
          'title': fieldsMap.articleTitle ? (Array.isArray(hit[fieldsMap.articleTitle]) ? hit[fieldsMap.articleTitle].join('') : hit[fieldsMap.articleTitle]) : null,
          'count': 0}
        // hit[fieldsMap.text] != null ? (hit[fieldsMap.text].match(new RegExp('(' + terms.join('|') + ')', 'gi')) ? hit[fieldsMap.text].match(new RegExp('(' + terms.join('|') + ')', 'gi')).length : '') : ''} // hit[fieldsMap.text].match(new RegExp('(' + highLightTerm.join('|') + ')', 'gi'))
      }).sort((a, b) => parseInt(a.position) > parseInt(b.position) ? 1 : -1)
      // console.log('async')
      // console.log(hits)
      // this.$store.dispatch('records/addSelectedRecordsPages', {id: cacheId, pages: hits})
      this.fetched = true
      // console.log(hits)
        // vm.hits = _.cloneDeep(this.hits)
      // hits.numFound = result.response…
      return {numFound: result.response.numFound, hits: hits}
      // return {numFound: hits.reduce((acc, x) => {
      //   if (acc.indexOf(x) === -1) { acc.push(x) }
      //   return acc
      // }, []).length,
      //   hits: hits}
    }
  },
  watch: {
    book: function () {
      this.page = 0
    },
    record: function () {
      let template = null
      try {
        template = this.fieldsMapping[this.book[2]]['settings']['pageCluster']['cite']
      } catch (e) {
        template = null
      }
      /* eslint-disable no-eval */
      // console.log(template, this.record, eval('`' + template + '`'))
      // this.cite = inject(template, this.record)
      /* eslint-disable no-eval */
      this.cite = template ? eval('`' + template + '`') : false
    }
  },
  methods: {
    goto: function (event) {
      this.page = parseInt($(event.target).attr('pageno'))
    },
    urlRewrite: function (url, source) {
      if (Array.isArray(url)) {
        url = url[0]
      }
      let fieldsMap = this.fieldsMapping[source]
      if (Array.isArray(fieldsMap.XAsia)) {
        url = fieldsMap.XAsia.reduce((acc, x) => {
          return acc.replaceAll(x, fieldsMap.original)
        }, url)
      } else {
        url = url.replaceAll(fieldsMap.XAsia, fieldsMap.original)
      }
      // console.log(fieldsMap.XAsia, fieldsMap.original)
      // url = url.startsWith('http') ? url : `http://${url}`
      // console.log(url)
      // alert('')
      if (fieldsMap.https) {
        url = url.replaceAll(/^http:/g, 'https:')
      }
      // book.url.replace(fieldsMapping[book.source].XAsia,fieldsMapping[book.source].original)
      return url
    },
    // refresh: function () {
    //   this.hits = _.cloneDeep(this.hits)
    //   alert(JSON.stringify(this.hits))
    // },
    highLight: function (text, expand) {
      let highLightTerm = this.highLightTerm
      // console.log(this.highLightTerm)
      let terms = highLightTerm.filter(function (obj) {
        return typeof obj === 'string' || obj instanceof String
      }).map(function (term) {
        if (term.match(/"[^"]*"/)) {
          return term.replace(/"/g, '')
        }
        return term
      // .replace(/\s*/g, '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') }).filter(function (term) { return term !== null && term.length > 0
      })

      const entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
      }
      function escapeHtml (string) {
        return String(string).replace(/[&<>"'`=/]/gm, function (s) {
          return entityMap[s]
        })
        // return String(string).replace(/[&<>"'`=/]/gm, '')
      }
      if (typeof text === 'string' || text instanceof String) {
        // console.log(text)
        let noOfCharacters = expand ? parseInt(this.charToShow.max) : parseInt(this.charToShow.min)

        text = escapeHtml(text.replace(/\s{1,}/gm, ' '))
        // console.log('(' + terms.join('|') + ')')
        var newText = text
        // console.log(this.book[2], this.fieldsMapping[this.book[2]].displayUnit)
        if (this.fieldsMapping[this.book[2]].displayUnit === 'word') {
          let lenOfWords = parseInt(this.wordToShow.min)
          if (expand) {
            lenOfWords = parseInt(this.wordToShow.max)
          }
          // console.log(this.wordToShow.max)
          // console.log(this.wordToShow.min)
          // console.log(lenOfWords)
          // console.log(terms)
          let wordRegex = new Array(lenOfWords).fill('[^<> ]+ +').join('')
          let _terms = terms.map(function (term) {
            // console.log(term)
            if (term.startsWith('\'') && term.endsWith('\'')) {
              term = term.replace(/^'/, '').replace(/'$/, '')
            }
            return term.split('').map(function (character) {
              if (character === '*') {
                return '[^\\s]*'
              } else if (character === '-') {
                return '(?:-|\\s)'
              } else {
                return character
              }
            }).join('[^\\w\\s]*').replace(/\s/g, ' *')
          })
          // console.log(_terms)
          // console.log(wordRegex)
          newText = text.replace(new RegExp('(^|\\s|\\(|（|$)(' + _terms.join('|') + ')', 'gi'), '$1<span style="color:#b41815">$2</span>').replace(new RegExp('(> ?' + wordRegex + ')[^<>]*?( ?' + wordRegex + '[^<> ]+ ?<)', 'gim'), '$1 ...<br/>... $2').replace(new RegExp('^[^<>]+( ?' + wordRegex + '[^<> ]+ ?<)', 'gi'), '... $1').replace(new RegExp('(> ?' + wordRegex + ')[^<>]+$', 'gi'), '$1 ...<br/>')
          if (newText === text) {
            newText = text.replace(new RegExp('(^|\\s|\\(|（|$)(' + _terms.join('') + ')', 'gi'), '$1<span style="color:blue">$2</span>').replace(new RegExp('(> ?' + wordRegex + ')[^<>]*?( ?' + wordRegex + '[^<> ]+ ?<)', 'gim'), '$1 ...<br/>... $2').replace(new RegExp('^[^<>]+( ?' + wordRegex + '[^<> ]+ ?<)', 'gi'), '... $1').replace(new RegExp('(> ?' + wordRegex + ')[^<>]+$', 'gi'), '$1 ...<br/>')
          }
        } else {
          let _terms = terms.map(function (term) {
            if (term.startsWith('\'') && term.endsWith('\'')) {
              term = term.replace(/^'/, '').replace(/'$/, '')
            }
            return term.split('').map(function (character) {
              if (character === '*') {
                return ''
              } else {
                return character
              }
            }).join('')
          })
          // console.log(terms)
          // console.log(terms.map(function (term) { return expandTerms(term) }).join('|'))
          // console.log('(^|\\s|$)(' + terms.map(function (term) { return expandTerms(term) }).join('|') + ')')
          newText = text.replace(new RegExp('(' + _terms.map(function (term) { return chineseTranslator.expandRegex(term) }).join('|') + ')', 'gi'), '<span style="color:#b41815">$1</span>').replace(new RegExp('(>[^<]{' + noOfCharacters + '})[^<]{' + noOfCharacters + ',}([^<]{' + noOfCharacters + '}<)', 'gim'), '$1 ...<br/>... $2').replace(new RegExp('^[^<]{' + noOfCharacters + ',}([^<]{' + noOfCharacters + '}<)', 'gi'), '... $1').replace(new RegExp('(>[^<]{' + noOfCharacters + '})[^<]{' + noOfCharacters + ',}$', 'gi'), '$1 ...<br/>')
          // newText = newText.split('').join('\0')
          // console.log(newText)
          if (newText === text) {
            newText = text.replace(new RegExp('([' + chineseTranslator.expandRegex(_terms.join('')).replace(/\[\]/, '') + '])', 'gi'), '<span style="color:blue">$1</span>').replace(new RegExp('(>[^<]{' + noOfCharacters + '})[^<]{' + noOfCharacters + ',}([^<]{' + noOfCharacters + '}<)', 'gim'), '$1 ...<br/>... $2').replace(new RegExp('^[^<]{' + noOfCharacters + ',}([^<]{' + noOfCharacters + '}<)', 'gi'), '... $1').replace(new RegExp('(>[^<]{' + noOfCharacters + '})[^<]{' + noOfCharacters + ',}$', 'gi'), '$1 ...<br/>')
          }
          if (newText === text) {
            let _terms = terms.map(function (term) {
              // console.log(term)
              if (term.startsWith('\'') && term.endsWith('\'')) {
                term = term.replace(/^'/, '').replace(/'$/, '')
              }
              return term.split('').map(function (character) {
                if (character === '*') {
                  return '[^\\s]*'
                } else if (character === '-') {
                  return '(?:-|\\s)'
                } else if (character === '\'') {
                  return '(?:\'|\\s)'
                } else {
                  return character
                }
              }).join('[^\\w\\s]*').replace(/\s/g, ' *')
            })
            // console.log('String: ' + _terms)
            // console.log(wordRegex)
            newText = text.replace(new RegExp('(^|\\s|\\(|（|$)(' + _terms.join('|') + ')', 'gi'), '$1<span style="color:#b41815">$2</span>').replace(new RegExp('(>[^<]{' + noOfCharacters + '})[^<]{' + noOfCharacters + ',}([^<]{' + noOfCharacters + '}<)', 'gim'), '$1 ...<br/>... $2').replace(new RegExp('^[^<]{' + noOfCharacters + ',}([^<]{' + noOfCharacters + '}<)', 'gi'), '... $1').replace(new RegExp('(>[^<]{' + noOfCharacters + '})[^<]{' + noOfCharacters + ',}$', 'gi'), '$1 ...<br/>')
            // console.log(newText)
            if (newText === text) {
              newText = text.replace(new RegExp('(^|\\s|\\(|（|$)(' + _terms.join('') + ')', 'gi'), '$1<span style="color:blue">$2</span>').replace(new RegExp('(>[^<]{' + noOfCharacters + '})[^<]{' + noOfCharacters + ',}([^<]{' + noOfCharacters + '}<)', 'gim'), '$1 ...<br/>... $2').replace(new RegExp('^[^<]{' + noOfCharacters + ',}([^<]{' + noOfCharacters + '}<)', 'gi'), '... $1').replace(new RegExp('(>[^<]{' + noOfCharacters + '})[^<]{' + noOfCharacters + ',}$', 'gi'), '$1 ...<br/>')
            }
          }
          let newLines = newText.split('<br/>')
          newText = newLines.map(function (line) {
            return line.replace(new RegExp('(</[^>]+>[^<]{' + parseInt(noOfCharacters * 0.6) + '})[^<]{1,}([^<]{' + parseInt(noOfCharacters * 0.6) + '}<)', 'gim'), '$1...<br/>...$2')
          }).join('<br/>')
        }
        return newText
      } else {
        return ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a.open {
 color: green !important;
 padding-right: 0.5em;
}

a.openButLoginRequired {
 color: orange !important;
 padding-right: 0.5em;
}

a.xAsia {
 color: #b41815 !important;
 padding-right: 0.5em;
}

a {
  color: #9D9D9D !important;
}

div.blockRange {
  margin-top:1em;
}
div {
  font-size: small;
}

div.row {
  margin-right:0px;
  margin-left:0px;
  width: 100%;
}

div.pages {
  overflow-y: auto;
  height: 500px;
}


a:hover  {
  color: black;
  cursor: pointer;
}

.animated-background {
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeHolderShimmer;
    animation-timing-function: linear;
    background: #f6f7f8;
    background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
    background-size: 800px 104px;
    height: 5em;
    position: relative;
}
.background-masker {
    background: #fff;
    position: absolute;
}
.background-masker.header {
    top: 0;
    right: 0;
    width: 50%;
    height: 1em;
}
.background-masker.header2 {
    top: 2em;
    right: 0;
    width: 70%;    
    height: 1em;
}
.background-masker.header3 {
    top: 4em;
    right: 0;
    width: 60%;    
    height: 1em;
}
.background-masker.header-no {
    top: 1em;
    left: 0;
    right: 0;
    height: 1em;
}
.background-masker.header-no2 {
    top: 3em;
    left: 0;
    right: 0;
    height: 1em;
}

.article {
  font-size: 1em;
  font-weight: bold;
  padding-bottom: 0.5em;
  padding-left: 15px;
}

.row.fulltext {
  padding-left: 15px;
}

hr {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
}

.full_text_scroller {
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/PageCluster.vue